import React, { useRef, useCallback } from 'react';
import '../styles/NameSeparator.css';

function NameSeparator() {
  const textRef = useRef(null);

  const handleMouseMove = useCallback((e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const dx = (e.clientX - cx) / rect.width; // -0.5 to 0.5
    if (textRef.current) {
      textRef.current.style.transform = `translateX(${dx * 28}px)`;
    }
  }, []);

  const handleMouseLeave = useCallback(() => {
    if (textRef.current) {
      textRef.current.style.transform = 'translateX(0px)';
    }
  }, []);

  return (
    <div className="name-sep" onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
      <div className="name-sep-bg" ref={textRef}>ANAIYSAA</div>
      <p className="name-sep-sub">open to new swe intern roles * 2026/2027</p>
    </div>
  );
}

export default NameSeparator;
